"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var usePrismicBrandInfo = function usePrismicBrandInfo(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicBrandInfo"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicBrandInfo;
exports["default"] = _default;